export default __webpack_public_path__ + "static/media/24.bd4b2a2f.jpg";